export default __webpack_public_path__ + "static/media/xy_banner.ab80985c.jpeg";